import * as React from 'react'

import { Space } from '../../atoms'
import { LinkStyledButton } from './linkIcon.styles'

export interface LinkProps {
  disabled?: boolean
  icon?: React.ReactNode
  iconPosition?: 'left' | 'right'
  onClick: () => void
  text: string
  underline?: boolean
}

export const LinkIcon = ({ disabled, icon, iconPosition, onClick, text, underline }: LinkProps) => (
  <LinkStyledButton disabled={disabled} underline={underline} onClick={onClick}>
    {iconPosition && iconPosition === 'left' && icon}
    <Space mx={2}>{text}</Space>
    {iconPosition && iconPosition === 'right' && icon}
  </LinkStyledButton>
)

export default LinkIcon
